import { Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';

/**
 * Connect is not available on mobile - the domain is taken and the only way
 * forward is desktop. Deliberately ignores `action`: no CTA, no live flow.
 */
export const MobileConnectOnDesktop = _ref => {
  let {
    domainName,
    datahook
  } = _ref;
  const {
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.mobile_results.domain_taken.connect_on_desktop",
    values: {
      domainName
    },
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "thin"
    })]
  }));
};
//# sourceMappingURL=MobileConnectOnDesktop.js.map